module.exports = __webpack_public_path__ + "48f8498408f94c40422fd38af0d9f0f5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/saxophone.png
// module id = 2601
// module chunks = 0